import { useEffect } from 'react';
import Moment from "moment";

/* Utilities */
import { pushDatalayer } from '../../../utilities/datalayer';

export default function ConversionFlowDataLayer({ flow = {}, activeStepId, inPage = false }) {
    const { datalayer } = flow || {};

    useEffect(() => {
        const activeStep = flow?.steps?.find(step => step.id === activeStepId) || null;

        if (inPage) return;
        if (!activeStep) return;

        let datalayerObject = {};

        switch (flow.flowName) {
            case 'reserve_online':

                if (activeStep.position === 2) {
                    datalayerObject['email'] = flow?.datalayer?.enriched?.email ? flow.datalayer.enriched.email : 'null';
                    datalayerObject['tenaamstelling'] = flow?.datalayer?.enriched?.tenaamstelling ? flow.datalayer.enriched.tenaamstelling : 'null';
                }

                pushDataLayerSteps(datalayerObject, 'reserve_online', activeStep);

                break;
            case 'interest':

                if (activeStep.position === 2) {
                    datalayerObject['email'] = flow?.datalayer?.enriched?.email ? flow.datalayer.enriched.email : 'null';
                }

                pushDataLayerSteps(datalayerObject, 'interesseaanvraag', activeStep);

                break;
            case 'finance':

                if (activeStep.position !== 1) {
                    datalayerObject['dimension17'] = (flow?.summary?.categories?.lease.values?.Financieringsprijs ? flow.summary.categories.lease.values.Financieringsprijs.value : 'null').toString().replace('€ ', '');
                    datalayerObject['dimension18'] = (flow?.datalayer?.enriched?.finance_type ? flow.datalayer.enriched.finance_type : 'null').toLowerCase();
                }

                if (activeStep.position === 2) {
                    datalayerObject['email'] = flow?.datalayer?.enriched?.email ? flow.datalayer.enriched.email : 'null';
                }

                if (activeStep.position === 3) {
                    datalayerObject['abonnement'] = (flow?.datalayer?.enriched?.abonnement ? flow.datalayer.enriched.abonnement : 'null').toLowerCase();
                    datalayerObject['afleverpakket'] = (flow?.summary?.categories?.options?.values?.Afleverpakketten ? flow.summary.categories.options.values.Afleverpakketten.value : 'Geen').toLowerCase();
                    datalayerObject['inruilvoorstel'] = (flow?.summary?.categories?.options?.values?.Inruilauto ? flow.summary.categories.options.values.Inruilauto.value : 'null').toLowerCase();
                    datalayerObject['bedrijfsnaam'] = (flow?.datalayer?.enriched?.bedrijfsnaam ? flow.datalayer.enriched.bedrijfsnaam : 'null').toLowerCase();
                    datalayerObject['email'] = flow?.datalayer?.enriched?.email ? flow.datalayer.enriched.email : 'null';
                }

                pushDataLayerSteps(datalayerObject, 'financieren', activeStep);

                break;
            case 'tradeproposal':

                if (activeStep.position === 2) {
                    datalayerObject['fotos'] = (flow?.datalayer?.enriched?.trade_in_images ? flow.datalayer.enriched.trade_in_images : 'null').toLowerCase();
                }

                if (activeStep.position === 3) {
                    datalayerObject['abonnement'] = (flow?.datalayer?.enriched?.abonnement ? flow.datalayer.enriched.abonnement : 'null').toLowerCase();
                    datalayerObject['afleverpakket'] = (flow?.datalayer?.enriched?.afleverpakket ? flow.datalayer.enriched.afleverpakket : 'null').toLowerCase();
                    datalayerObject['verzekeren'] = (flow?.datalayer?.enriched?.verzekeren ? flow.datalayer.enriched.verzekeren : 'null').toLowerCase();
                    datalayerObject['email'] = flow?.datalayer?.enriched?.email ? flow.datalayer.enriched.email : 'null';
                }

                pushDataLayerSteps(datalayerObject, 'inruilvoorstel', activeStep);

                break;
            case 'taxation':

                if (activeStep.position === 2) {
                    datalayerObject['dimension2'] = datalayer?.enriched?.merk ? datalayer.enriched.merk : 'null',
                    datalayerObject['dimension3'] = datalayer?.enriched?.model ? datalayer.enriched.model : 'null',
                    datalayerObject['dimension5'] = datalayer?.enriched?.tellerstand ? datalayer.enriched.tellerstand : 'null',
                    datalayerObject['fotos'] = datalayer?.enriched?.afbeeldingen ? 'ja' : 'nee';
                }

                if (activeStep.position === 3) {
                    datalayerObject['email'] = flow?.datalayer?.enriched?.email ? flow.datalayer.enriched.email : 'null';
                }

                pushDataLayerSteps(datalayerObject, 'taxatievoorstelaanvraag', activeStep);

                break;
            case 'test_drive':

                if (activeStep.position === 2) {
                    const date = Moment(flow.datalayer.enriched.datum).format('DD-MM-YYYY');
                    datalayerObject['datum'] = flow?.datalayer?.enriched?.datum ? date : 'null';
                    datalayerObject['tijdstip'] = flow?.datalayer?.enriched?.tijd ? flow.datalayer.enriched.tijd : '';
                }

                if (activeStep.position === 3) {
                    datalayerObject['email'] = flow?.datalayer?.enriched?.email ? flow.datalayer.enriched.email : 'null';
                }

                pushDataLayerSteps(datalayerObject, 'proefritaanvraag', activeStep);

                break;
            case 'business_lease_enquire':

                datalayerObject['dimension18'] = 'zakelijk';

                if (activeStep.position !== 1) {
                    datalayerObject['km_per_jaar'] = (flow?.summary?.categories?.summary?.values['Kilometers per jaar'] ? flow.summary.categories.summary.values['Kilometers per jaar'].value : 'null').toLowerCase();
                    datalayerObject['looptijd'] = (flow?.summary?.categories?.summary?.values['Looptijd'] ? flow.summary.categories.summary.values['Looptijd'].value : 'null').toLowerCase();
                }

                if (activeStep.position === 3) {
                    datalayerObject['email'] = flow?.datalayer?.enriched?.email ? flow.datalayer.enriched.email : 'null';
                }

                if (activeStep.position === 3) {
                    datalayerObject['kvk'] = (flow?.datalayer?.enriched['KVK Nummer'] ? flow.datalayer.enriched['KVK Nummer'] : 'null').toLowerCase();
                }

                pushDataLayerSteps(datalayerObject, 'leaseaanvraag', activeStep);

                break;
            case 'lease_enquire':

                datalayerObject['dimension18'] = 'particulier';

                if (activeStep.position !== 1) {
                    datalayerObject['km_per_jaar'] = (flow?.summary?.categories?.summary?.values['Kilometers per jaar'] ? flow.summary.categories.summary.values['Kilometers per jaar'].value : 'null').toLowerCase();
                    datalayerObject['looptijd'] = (flow?.summary?.categories?.summary?.values['Looptijd'] ? flow.summary.categories.summary.values['Looptijd'].value : 'null').toLowerCase();
                }

                if (activeStep.position === 3) {
                    datalayerObject['email'] = flow?.datalayer?.enriched?.email ? flow.datalayer.enriched.email : 'null';
                }

                pushDataLayerSteps(datalayerObject, 'privateleaseaanvraag', activeStep);

                break;

            case 'lease_configurator':

                if (activeStep.position === 2) {
                    datalayerObject['form_step_name'] = 'Details';
                    datalayerObject['abonnement'] = (flow?.datalayer?.enriched?.abonnement ? flow.datalayer.enriched.abonnement : 'null').toLowerCase();
                    datalayerObject['kilometrage'] = (flow?.datalayer?.enriched?.kilometrage ? flow.datalayer.enriched.kilometrage : 'null').toLowerCase();
                    datalayerObject['eigen_risico'] = (flow?.datalayer?.enriched?.eigen_risico ? flow.datalayer.enriched.eigen_risico : 'null').toLowerCase();
                    datalayerObject['banden'] = (flow?.datalayer?.enriched?.banden ? flow.datalayer.enriched.banden : 'null').toLowerCase();
                    datalayerObject['opties'] = (flow?.datalayer?.enriched?.opties ? flow.datalayer.enriched.opties : 'null').toLowerCase();
                    datalayerObject['schade_vrije_jaren'] = (flow?.datalayer?.enriched?.schade_vrije_jaren ? flow.datalayer.enriched.schade_vrije_jaren : 'null').toLowerCase();
                    datalayerObject['vervangend_vervoer'] = (flow?.datalayer?.enriched?.vervangend_vervoer ? flow.datalayer.enriched.vervangend_vervoer : 'null').toLowerCase();
                    datalayerObject['services'] = (flow?.datalayer?.enriched?.services ? flow.datalayer.enriched.services : 'null').toLowerCase();
                }

                if (activeStep.position === 3) {
                    datalayerObject['form_step_name'] = 'Voltooid'
                    datalayerObject['email'] = flow?.datalayer?.enriched?.email ? flow.datalayer.enriched.email : 'null';
                }

                pushDataLayerSteps(datalayerObject, 'Lease Samenstellen', activeStep);

                break;
            default:
                break;
        }
    }, [activeStepId]);

    const pushDataLayerSteps = (datalayerObject, flowName, activeStep) => {
        pushDatalayer({
            page_event: 'form_data',
            page_type: 'form',
            form_name: flowName,
            form_step: activeStep?.last ? 'voltooid' : activeStep?.position,
            event: 'form',
            items: flowName !== 'taxatievoorstelaanvraag' ? getVehicleData() : [],
            ...datalayerObject
        });
    }

    const getVehicleData = () => {
        const item_brand = flow?.summary?.vehicle?.brand ? flow.summary.vehicle.brand : 'null';
        const item_model = flow?.summary?.vehicle?.model ? flow.summary.vehicle.model : 'null';
        const item_name = `${item_brand} ${item_model}`;

        return [
            {
                item_name,
                item_source:                    `${flow?.summary?.vehicle?.source === 'Occassion' ? 'gebruikt' : 'nieuw'}`,
                item_brand,
                item_model,
                item_price:                     `${flow?.summary?.vehicle?.price ? flow.summary.vehicle.price : 'null'}`,
                item_odemeter_distance:         `${flow?.summary?.vehicle?.tellerstand ? flow.summary.vehicle.tellerstand : 'null'}`,
                item_construction_year:         `${flow?.summary?.vehicle?.bouwjaar ? flow.summary.vehicle.bouwjaar : 'null'}`,
                item_fuel_type:                 `${flow?.summary?.vehicle?.brandstof ? flow.summary.vehicle.brandstof : 'null'}`,
                item_transmission:              `${flow?.summary?.vehicle?.transmissie ? flow.summary.vehicle.transmissie : 'null'}`,
                item_body:                      `${flow?.summary?.vehicle?.carrosserie ? flow.summary.vehicle.carrosserie : 'null'}`,
                item_color:                     `${flow?.summary?.vehicle?.kleur ? flow.summary.vehicle.kleur : 'null'}`,
                item_establishment:             `${flow?.summary?.vehicle?.vestiging ? flow.summary.vehicle.vestiging : 'null'}`,
                item_average_usage:             `${flow?.summary?.vehicle?.gemiddeld_verbruik ? flow.summary.vehicle.gemiddeld_verbruik: 'null'}`,
            }
        ];
    };

    return null;
}
